export default "__VITE_ASSET__a2021fb7__"